<template>
    <b-modal :active="isOpen">
      <div >
      <div class="modal-header">
        <h1>Uploadning af csv fil</h1>
      </div>
      <div class="modal-body">
        <div>
          <div>
         
        <b-field label="Type" style="padding: 15px 20px;">
            <b-select 
            expanded
            v-bind:value="discriminator"
            @input="setDiscriminator"
          > 
            <option
              v-for="(discriminator) in discriminatorOptions"
              :key="discriminator.key"
              :value="discriminator"
            >
              {{ discriminator.value }}
            </option>
          </b-select>
        </b-field>
        </div>
          <b-button style="padding:5px" type="is-green" @click="promptFile()">Tilføj CSV fil</b-button>    
        <input  type="file" ref="fileInput" @change="saveFile" accept=".csv" style="display: none;" />
        
        </div>
      </div>
      <div class="modal-footer">
        <b-button class="is-blue" @click="uploadFile">Upload</b-button>
        <b-button class="is-text" @click="setModalOpen(false)">Annullér</b-button>
      </div>
      </div>
    </b-modal>
  </template>
  
  <script>
  import { mapActions, mapGetters } from "vuex";
  
  export default {
    name: "csv-modal",
    data: () => ({}),
    async mounted(){
    },
    computed: {
      ...mapGetters("csvModalStore", [
        "isOpen",
        "discriminator",
        "discriminatorOptions",
        "selectedFile"
      ]),
    },
    methods: {
    promptFile() {
      this.$refs.fileInput.click();
    },
    saveFile(event) {
        
        this.setSelectedFile(event.target.files[0]);
    },
      ...mapActions("csvModalStore", ["setModalOpen", "setDiscriminator", "setSelectedFile", "uploadFile"]),
    }
  };
  </script>
  
  <style lang="scss" scoped>
  
  .modal-header {
    border-radius: 10px 10px 0px 0px;
    background: white;
    height: 50px;
    width: 400px;
    text-align: start;
    margin: auto;
    h1 {
      padding: 10px;
      font-size: 20px;
    }
  }
  .modal-body {
    background: white;
    margin: auto;
    width: 400px;
    border-top: 1px solid lightgrey;
    h2 {
      font-size: 15px;
      padding: 12px 15px 15px 35px;
      width: 300px;
      text-align: start;
    }
  }
  
  .inline-block {
    display: inline-block;
  }
  .exclamation-icon {
    margin: 0;
    position: absolute;
    top: 45%;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
  }
  
  .modal-footer {
    background: white;
    width: 400px;
    border-top: 1px solid lightgrey;
    height: 70px;
    border-radius: 0px 0px 10px 10px;
    margin: auto;
  }
  .button {
    margin: 15px;
  }
  </style>
  